import { Check, X } from 'lucide-react'
import { ArrowRight } from 'lucide-react'
import { TELEGRAM_BOT_URL } from '@/lib/constants'
import { useScrollReveal } from '@/hooks/useScrollReveal'

const ROWS = [
  { label: 'Historial verificable públicamente', tipster: false, ja: true },
  { label: 'ROI auditado por terceros', tipster: false, ja: true },
  { label: 'Win rate calculado sobre picks liquidados', tipster: false, ja: true },
  { label: 'Inteligencia Artificial en la decisión', tipster: false, ja: true },
  { label: 'Transparencia total en cada pick', tipster: false, ja: true },
  { label: 'Explicación estadística del pick', tipster: false, ja: true },
  { label: 'Actualización automática diaria', tipster: false, ja: true },
  { label: 'Sin sesgo emocional ni intuición', tipster: false, ja: true },
]

export function ComparisonSection() {
  const ref = useScrollReveal<HTMLElement>()

  return (
    <section ref={ref} className="max-w-5xl mx-auto px-5 py-20">
      <div className="text-center mb-12 reveal">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand mb-2">
          Comparativa
        </p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold">
          Tipster tradicional vs{' '}
          <span className="text-brand">John Anthony</span>
        </h2>
        <p className="mt-3 text-text-dim max-w-lg mx-auto text-sm leading-relaxed">
          No hablamos mal de nadie. Solo mostramos diferencias objetivas entre un enfoque manual y un sistema de IA.
        </p>
      </div>

      <div className="reveal card overflow-hidden p-0" style={{ transitionDelay: '120ms' }}>
        {/* Header */}
        <div className="grid grid-cols-[1fr_120px_120px] sm:grid-cols-[1fr_160px_160px] border-b border-border bg-panel-elevated">
          <div className="p-4 sm:p-5" />
          <div className="p-4 sm:p-5 text-center border-l border-border">
            <p className="text-xs font-semibold uppercase tracking-wider text-text-dim">
              Tipster
            </p>
            <p className="text-xs text-text-dim mt-0.5">Tradicional</p>
          </div>
          <div className="p-4 sm:p-5 text-center border-l border-border bg-brand-soft/40">
            <p className="text-xs font-semibold uppercase tracking-wider text-brand">
              John Anthony
            </p>
            <p className="text-xs text-brand/70 mt-0.5">IA & Datos</p>
          </div>
        </div>

        {/* Rows */}
        {ROWS.map((row, i) => (
          <div
            key={row.label}
            className={`grid grid-cols-[1fr_120px_120px] sm:grid-cols-[1fr_160px_160px] ${
              i !== ROWS.length - 1 ? 'border-b border-border' : ''
            }`}
          >
            <div className="p-4 sm:p-5 flex items-center">
              <span className="text-sm text-text-dim">{row.label}</span>
            </div>
            <div className="p-4 sm:p-5 flex items-center justify-center border-l border-border">
              {row.tipster ? (
                <Check className="h-4 w-4 text-brand" />
              ) : (
                <X className="h-4 w-4 text-text-dim/40" />
              )}
            </div>
            <div className="p-4 sm:p-5 flex items-center justify-center border-l border-border bg-brand-soft/20">
              {row.ja ? (
                <Check className="h-5 w-5 text-brand" />
              ) : (
                <X className="h-4 w-4 text-text-dim/40" />
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="cta-strip reveal" style={{ transitionDelay: '200ms' }}>
        <a href={TELEGRAM_BOT_URL} target="_blank" rel="noopener noreferrer" className="btn-brand">
          Probar John Anthony gratis
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </a>
      </div>
    </section>
  )
}
